<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button color="medium" @click="cancel">ยกเลิก</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <div data-card-height="240" class="card card-style rounded-m shadow-xl preload-img entered mt-4 loaded bg-wallet"
         data-ll-status="loaded" style="height: 240px; background-image: url(&quot;images/pictures/18w.jpg&quot;);">
      <div class="card-top mt-4 me-3">
        <button @click="openModal(components.Wallet)" class="mt-1 float-end text-uppercase font-900 font-11 btn btn-s rounded-s shadow-l bg-green-light">เติมเครดิต</button>
      </div>
      <div class="card-center text-center">
        <h1 class="fa-4x">{{ Number(wallet[0]?.balance).toLocaleString() }}</h1>
      </div>
      <div class="card-bottom">
        <p class="ms-3 font-15 font-500 mb-2">{{ auth.user?.line_id }}</p>
      </div>
      <div class="card-bottom">
        <p class="text-end me-3 font-15 font-500 mb-2 mb-2">UID : {{ auth.user?.id }}</p>
      </div>
      <div class="card-overlay bg-wallet"></div>
    </div>
    <div class="card card-style">
      <div class="content">
        <div class="d-flex mb-3">
          <div class="me-3">
            <h4 class="font-18">ยอดคงเหลือ</h4>
          </div>
          <div class="ms-auto">
            <h4 class="font-18">{{ Number(wallet[0]?.balance).toLocaleString() }}</h4>
          </div>
        </div>
        <div class="divider mb-3"></div>
        <div class="d-flex mb-3">
          <div class="me-3">
            <h4 class="font-18">ยอดชำระ</h4>
          </div>
          <div class="ms-auto">
            <h4 class="font-18">{{ Number(order.total).toLocaleString() }}</h4>
          </div>
        </div>
        <div class="d-flex mb-3">
          <div class="me-3">
            <h4 class="font-18">ส่วนลด</h4>
          </div>
          <div class="ms-auto">
            <h4 class="font-18">0</h4>
          </div>
        </div>
        <div class="divider mb-3"></div>
        <div class="d-flex mb-3">
          <div class="me-3">
            <h4 class="font-25 color-green-light">ยอดสุทธิ</h4>
          </div>
          <div class="ms-auto">
            <h4 class="font-25 color-green-light">{{ Number(order.total).toLocaleString() }}</h4>
          </div>
        </div>
        <div class="divider"></div>
        <button @click="send" class="btn btn-full w-100 bg-green-dark btn-m text-uppercase font-800 rounded-sm">ยืนยันการชำระเงิน</button>
      </div>
    </div>
  </ion-content>
</template>

<script>
import {
  alertController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonToolbar,
  loadingController,
  modalController
} from '@ionic/vue';
import Wallet from "@/views/payment/WalletTopup.vue";

export default {
  name: 'BankModal',
  components: {
    IonHeader,
    IonToolbar,
    IonContent,
    IonButtons,
    IonButton,
  },
  props: {
    payments: Object,
    order: Object
  },
  mounted() {
    this.emitter.on('login', async () => {
      await this.getUser();
    })
    this.getUser();
  },
  data() {
    return {
      auth: [],
      wallet: [],
      components: {
        Wallet : Wallet
      }
    }
  },
  methods: {
    async getContact() {
      const response = await this.axios.get(`/profile`);
      this.contact = response.data.result;
      this.wallet = response.data.result.wallet;
    },
    async getUser() {
      this.auth = await this.storage.get('auth');
      if (this.auth) {
        this.isAuth = true;
        await this.getContact();
      } else {
        this.isAuth = false;
      }
    },
    cancel() {
      return modalController.dismiss(null, 'cancel');
    },
    async confirm() {
      await this.storage.remove('cart');
      this.emitter.emit('toggle-cart');
      this.loading = await loadingController.create({
        message: 'กำลังพาท่านไปที่หน้าส่งสลิป',
        spinner: 'circles',
        mode: 'ios'
      })

      await this.loading.present();
      setTimeout(async () => {
        await modalController.dismiss(this.name, 'oa');
      }, 2000)
    },
    numberformat(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async send() {
      try {
        this.loading = await loadingController.create({
          message: 'กำลังตรวจสอบข้อมูล',
          spinner: 'circles',
          mode: 'ios'
        })

        await this.loading.present();
        const response = await this.axios.put(`/deposit/1`, {
          amount : this.order.total,
          order_id : this.order.id
        })

        await this.loading.dismiss();
        await modalController.dismiss(this.name, 'confirm');
        const alert = await alertController.create({
          header: 'สำเร็จ',
          subHeader: response.data.message,
          buttons: ['ปิด'],
          mode: "ios"
        });

        await alert.present();
      } catch (error) {
        await this.loading.dismiss();
        const alert = await alertController.create({
          header: 'ขออภัย',
          subHeader: error.response.data.message ?? "กรุณาตรวจสอบสลิป",
          buttons: ['ปิด'],
          mode: "ios"
        });

        await alert.present();
      }
    },
    async openModal(component) {
      const modal = await modalController.create({
        component: component,
        initialBreakpoint: 1,
        breakpoints: [0, 1],
        mode: 'ios',
      });
      await modal.present();

      const {data, role} = await modal.onDidDismiss();

      if (role === 'success') {
        await this.getContact();
      }
    },
  }
}
</script>
<style scoped>
.block {
  width: 100%;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-modal {
  --height: auto;
}

.bg-wallet {
  background-image: url("@/assets/images/wallet.png");
  background-size: 100% 100% !important;
}
</style>
